import { doc, updateDoc, serverTimestamp, increment } from 'firebase/firestore';
import { db } from '@/shared/config/firebase';

/**
 * Records a project visit for a user.
 * Updates the projectVisits map with count and lastVisit.
 */
export async function trackProjectVisit(userId: string, projectId: string): Promise<void> {
  const userRef = doc(db, 'users', userId);

  await updateDoc(userRef, {
    [`projectVisits.${projectId}.count`]: increment(1),
    [`projectVisits.${projectId}.lastVisit`]: serverTimestamp(),
  });
}
